import { type Timestamp, timestampDate } from '@bufbuild/protobuf/wkt'

import { Box, LightModeSemanticColors } from '@enechain/ecloud-designsystem'

import { useMemberDisplayName } from '~/hooks/member/useMemberDisplayName'
import { formatMonthDayTime } from '~/models/dateTime'

type Props = {
  /**
   * 更新者の eauth member ID (= auth0 subject)。 表示時に `useMemberDisplayName`
   * で表示名へ解決し、 解決できない場合は行ごと省略する (= 生 ID を出さない)。
   */
  updatedBy: string | undefined
  updatedAt: Timestamp | undefined
}

const NO_VALUE = '—'

export const AuditCell = ({
  updatedBy,
  updatedAt,
}: Props): React.ReactElement => {
  const resolveDisplayName = useMemberDisplayName()

  if (updatedAt === undefined) {
    return (
      <span style={{ color: LightModeSemanticColors.Text.lowEmphasis.value }}>
        {NO_VALUE}
      </span>
    )
  }

  const dateLabel = formatMonthDayTime(timestampDate(updatedAt))
  const updatedByName = resolveDisplayName(updatedBy)
  // nowrap (= 監査スタンプを 1 行に保つ) は host 側の td 契約で担保する:
  // MasterDataTable 消費者は列に `nowrap: true` を、 生 table (TradingPartnerTable /
  // EsljAccountTable) は当該セルの td に `whiteSpace: 'nowrap'` を持たせている。
  return (
    <Box lineHeight="1.3">
      <Box fontSize="sm">{dateLabel}</Box>
      {updatedByName !== undefined && (
        <Box color="Text.lowEmphasis" fontSize="xs">
          {updatedByName}
        </Box>
      )}
    </Box>
  )
}
